import { FeeServiceEnum } from "../../enums/fee-service.enum";

export interface FeeConfigRequest {
    serviceType: string;
    name: string;
    type: 'percentual' | 'valor';
    value: number;
    description?: string;
    isActive?: boolean;
}

export interface FeeFormPayloadRequest {
    numero_cnpj: string;
    pixCashin: number;
    pixStaticCashin: number;
    boletoCashin: number;
    pixCashout: number;
    pixCashinSemStatus: number;
    //
    pixCashinValue: number;
    pixStaticCashinValue: number;
    boletoCashinValue: number;
    pixCashoutValue: number;
    pixCashinSemStatusValue: number;

}

